<div class="footer">
  <img src="../../../assets/images/bio2Logo.png" alt="bio2Logo">
  <span>Copyright 2024 - {{ getCurrentYear() > 2024 ? getCurrentYear() : '' }} representação e comércio de produtos
    veterinários e agro-pecuários,
    S.A.</span>
</div>
